import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Trackinglinks',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Sociale media',
  },
  form: {
    utm_source: {
      label: 'Bron',
      placeholder: 'Bron selecteren',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Overige sociale media',
        [CustomUtmSource.Other]: 'Overig',
      },
    },
    utm_source_details: {
      label: 'Aangepaste bron',
      placeholder: 'Voer bron in',
    },
    target_product: {
      label: 'Doel',
      placeholder: 'Selecteer doel',
    },
    target_url: {
      label: 'Doel-URL',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Medium',
      placeholder: 'Voer medium in',
    },
    utm_campaign: {
      label: 'Campagne',
      placeholder: 'Voer campagne in',
    },
  },
  fields: {
    utm_source: 'Bron',
    target_product: 'Doel',
    type: 'Type',
    utm_medium: 'Medium',
    utm_campaign: 'Campagne',
    utm_referrer_id: 'Referrer-ID',
  },
  buttons: {
    create_auto_links: 'Automatische links aanmaken',
    create_link: 'Link aanmaken',
    create: 'Aanmaken',
    update: 'Bijwerken',
    copy_link: 'Link kopiëren',
    download_qr_code: 'QR-code downloaden',
    edit: 'Bewerken',
  },
  modals: {
    auto_links_creation: {
      title: 'Weet u het zeker?',
      description:
        'Zorg dat de winkelconfiguratie volledig is (subdomein online shop / storefront-domein). Wijzigingen hierin na het aanmaken van links worden niet automatisch doorgevoerd in bestaande links!',
    },
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
    link_got_copied: 'Link gekopieerd!',
    failed_to_download_qr_code: 'QR-code downloaden mislukt',
  },
};
